export const environment = {
  name: 'prod',
  production: true,
  maintenanceMode: false,
  showAccessBanner: false,
  useEntraId: true,
  openidUrl: 'https://corp.sts.ford.com/adfs/oauth2',
  openidClientId: 'urn:agenda:clientid:web_agendadealer:prod',
  openidResource: 'urn:agenda:resource:web_agendadealer:prod',
  openidRedirectUrl: '',
  bffUrl: 'https://api.service.ford.com/agenda/manage-reservation-bff',
  dealerTransformationUrl: 'https://mfe.agenda.ford.com/home',
  workshopOldUrl: 'https://mfe.agenda.ford.com/workshop-old',
  workshopUrl: 'https://mfe.agenda.ford.com/workshop',
  backofficeUrl: 'https://backoffice.agenda.ford.com',
  msalConfig: {
    clientId: 'a533b637-0822-4b55-b374-2e16fefaa65a',
    authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
    redirectUri: 'https://dealer.agenda.ford.com',
  },
  apiConfig: {
    manageReservationBff: {
      uri: 'https://api.service.ford.com/agenda/manage-reservation-bff',
      scopes: ['api://0744f23b-9b0a-4ede-a83d-be901ed7a91f/webapp'],
    },
  },
};